import React from "react"
import ScrollToTopLink from "./ScrollToTopLink"
import { useAuth } from "../context/AuthContext"
import { useLanguage } from "../context/LanguageContext"

export default function Footer() {
  const { user } = useAuth()
  const { t } = useLanguage()

  const authenticatedFooterItems = [
    { name: t("dashboard"), path: "/dashboard" },
    { name: t("reading"), path: "/reading" },
    { name: t("writing"), path: "/writing" },
    { name: t("listening"), path: "/listening" },
    { name: t("speaking"), path: "/speaking" },
    { name: t("vocabulary"), path: "/vocabulary" },
    { name: t("grammar"), path: "/grammar" },
    { name: t("activities"), path: "/activities" },
    { name: t("profile"), path: "/profile" },
  ]

  const publicFooterItems = [
    { name: t("home"), path: "/" },
    { name: t("login"), path: "/login" },
    { name: t("signup"), path: "/signup" },
  ]

  const footerItems = user ? authenticatedFooterItems : publicFooterItems

  const supportItems = [
    {
      name: t("contactUs") || "Contact Us",
      href: "https://wa.me/6587625331",
      external: true,
    },
    { name: t("submitSuggestion"), path: "/feedback" },
    { name: t("termsAndConditions"), path: "/terms" },
  ]

  return (
    <footer className="site-chrome site-chrome--footer relative z-20">
      <div className="site-chrome-inner py-4 sm:py-5">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <ScrollToTopLink to="/" className="site-brand self-start">
            <img src="/logo.png" alt="Cosmic Learning logo" />
            <span className="leading-none">
              Cosmic&nbsp;
              <span className="text-accent">Learning</span>
            </span>
          </ScrollToTopLink>

          <nav className="flex flex-wrap items-center gap-x-0.5 gap-y-1" aria-label={t("navigation")}>
            {footerItems.map((item) => (
              <ScrollToTopLink key={item.path} to={item.path} className="site-nav-link">
                {item.name}
              </ScrollToTopLink>
            ))}
          </nav>

          <nav className="flex flex-wrap items-center gap-x-0.5 gap-y-1" aria-label={t("support")}>
            {supportItems.map((item) =>
              item.external ? (
                <a
                  key={item.href}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="site-nav-link"
                >
                  {item.name}
                </a>
              ) : (
                <ScrollToTopLink key={item.path} to={item.path} className="site-nav-link">
                  {item.name}
                </ScrollToTopLink>
              )
            )}
          </nav>
        </div>

        <p className="mt-4 pt-4 border-t border-border text-xs text-muted-foreground">
          © {new Date().getFullYear()} Cosmic Learning. {t("allRightsReserved") || "All rights reserved."}
        </p>
      </div>
    </footer>
  )
}
